import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

Vue.use(Vuex)

export default new Vuex.Store({

   modules: {

      loginlogout: {
         state: {
            portinvoiceUserID: '',
            loadingStartScreen: true,
            loadingWorkingScreen: false,
            email: '',
            mandant: '',
            accessTicket: '',
            documents: [],
            documentWithMetaData: {},
            markerForward: '',
            markerBackward: '',
            allMarkers: [],
            page: 0,
            relations: [],
            maxRowsPerPage: '',
            searchQuery: '',
            searchParameter: {},
            trefferAnzahl: 0,
            sortSetting: {}
         },
         mutations: {
            auth_success_portinvoice(state, portinvoiceUserID) {
               state.portinvoiceUserID = portinvoiceUserID
            },
            setMandant(state, mandant) {
               state.mandant = mandant
            },
            setTicket(state, accessTicket) {
               state.accessTicket = accessTicket
            },
            setDocuments(state, doc) {
               state.documents = doc
            },
            emptyDocuments(state) {
               state.documents = []
            },
            setLoadingWorkingScreen(state) {
               state.loadingWorkingScreen = true
            },
            setStopLoadingWorkingScreen(state) {
               state.loadingWorkingScreen = false
            },
            // setDocumentWithMetaData(state, doc) {
            //    state.documentWithMetaData.push(doc)
            // },
            setLoadedPDFMetaData(state, doc) {
               state.documentWithMetaData = doc
            },

            addPageMarkerForward(state, marker) {
               state.markerForward = marker
            },
            // addPageMarkerBackward(state, marker) {
            //    state.markerBackward = marker
            // },
            saveAllMarkers(state, marker) {
               if (!state.allMarkers.includes(marker)) {
                  state.allMarkers.push(marker)
               }
               //console.log(state.allMarkers)
            },
            emptyAllMarkers(state) {
               state.allMarkers = []
            },
            addPage(state) {
               state.page = state.page + 1
            },
            subtractPage(state) {
               if (state.page != 0) {
                  state.page = state.page - 1
               }
            },
            setPageToZero(state) {
               state.page = 0
            },
            setDocumentRelations(state, relations) {
               state.relations = relations
            },
            setMaxRowsPerPage(state, maxRowsPerPage) {
               state.maxRowsPerPage = maxRowsPerPage
            },
            setSearchQuery(state, searchQuery) {
               state.searchQuery = searchQuery
            },
            setSearchParameter(state, searchParameter) {
               state.searchParameter = searchParameter
            },
            setTrefferAnzahl(state, trefferAnzahl) {
               state.trefferAnzahl = trefferAnzahl
            },
            setSortSetting(state, sortSetting) {
               state.sortSetting = sortSetting
            }
         },
         actions: {

            isPortinvoiceLoggedIn({ commit, dispatch }, data) {
               commit('setLoadingWorkingScreen')
               return new Promise((resolve, reject) => {
                  axios({
                     url: data.restURL + '/custom/v1/is-portinvoice-logged-in',
                     method: 'GET',
                     params: {
                        '_wpnonce': data.nonce
                     },
                     headers: {
                        'content-type': 'application/json'
                     }
                  })
                  .then(resp => {
                     var newData = {
                        'nonce': data.nonce,
                        'restURL': data.restURL
                     }
                     var user_id = resp.data.user_id
                     var mandantenname = resp.data.mandantenname
                     if (data.customer) {
                        dispatch('hasBoughtMailEdition', newData)
                           .then(resp => {
                              if (resp.data.active == "yes") {
                                 commit('auth_success_portinvoice', user_id)
                                 commit('setMandant', mandantenname)
                              } else {
                                 commit('auth_success_portinvoice', '')
                                 commit('setMandant', '')
                              }
                              resolve(resp)
                           })
                           .catch(err => {
                              console.log(err)
                              commit('auth_success_portinvoice', '')
                              commit('setMandant', '')
                              reject(err)
                           })
                     } else {
                        commit('auth_success_portinvoice', user_id)
                        commit('setMandant', mandantenname)
                        resolve(resp)
                     }
                  })
                  .catch(err => {
                     commit('auth_success_portinvoice', '')
                     commit('setMandant', '')
                     reject(err)
                  })
               })
            },

            hasBoughtMailEdition({ commit }, data) {
               return new Promise((resolve, reject) => {
                  axios({
                     url: data.restURL + '/custom/v1/hasActiveMailEditionSubscription',
                     method: 'GET',
                     params: {
                        '_wpnonce': data.nonce
                     },
                     headers: {
                        'content-type': 'application/json'
                     }
                  })
                  .then(resp => {
                     resolve(resp)
                  })
                  .catch(err => {
                     reject(err)
                  })
               })               
            },

            checkAndCreatePortinvoiceTicket({ commit }, data) {
               return new Promise((resolve, reject) => {
                  axios({
                     url: data.restURL + '/custom/v1/checkAndCreatePortinvoiceTicket',
                     method: 'GET',
                     params: {
                        '_wpnonce': data.nonce
                     },
                     headers: {
                        'content-type': 'application/json'
                     }
                  })
                  .then(resp => {
                     resolve(resp)
                  })
                  .catch(err => {
                     reject(err)
                  })
               })
            },

            retrieveTicket({ commit }, data) {
               return new Promise((resolve, reject) => {
                  axios({
                     url: data.restURL + '/custom/v1/getTicketFromDatabase',
                     method: 'GET',
                     params: {
                        '_wpnonce': data.nonce
                     },
                     headers: {
                        'content-type': 'application/json'
                     }
                  })
                  .then(resp => {
                     commit('setTicket', resp.data.ticket)
                     resolve(resp)
                  })
                  .catch(err => {
                     reject(err)
                  })
               })
            },

            logoutTicket({ commit }, data) {
               return new Promise((resolve, reject) => {
                  axios({
                     url: data.restURL + '/custom/v1/logoutTicket',
                     method: 'GET',
                     params: {
                        '_wpnonce': data.nonce,
                        //'ticket': data.ticket
                     },
                     headers: {
                        'content-type': 'application/json'
                     }
                  })
                  .then(resp => {
                     resolve(resp)
                  })
                  .catch(err => {
                     reject(err)
                  })
               })
            },

            showDocument({ commit }, data) {
               return new Promise((resolve, reject) => {
                  axios({
                     url: data.restURL + '/custom/v1/Document',
                     method: 'GET',
                     params: {
                        '_wpnonce': data.nonce,
                        'noderef': data.noderef,
                        //'ticket': data.ticket
                     },
                     headers: {
                        'content-type': 'application/pdf'
                     }
                  })
                  .then(resp => {
                     //console.log(resp.data)
                     resolve(resp)
                  })
                  .catch(err => {
                     reject(err)
                  })                  
               })    
            },

            getDocuments({ commit }, data) {
               return new Promise((resolve, reject) => {
                  axios({
                     url: data.restURL + '/custom/v1/getDocuments',
                     method: 'GET',
                     params: {
                        '_wpnonce': data.nonce,
                        //'ticket': data.ticket,
                        'mandant': data.mandant,
                        'query': data.query
                     },
                     headers: {
                        'content-type': 'application/json'
                     }
                  })
                  .then(resp => {
                     resolve(resp)
                  })
                  .catch(err => {
                     reject(err)
                  })
               })
            },

            getDocumentsMarkedQuery({ commit }, data) {
               return new Promise((resolve, reject) => {
                  axios({
                     url: data.restURL + '/custom/v1/getDocumentsMarkedQuery',
                     method: 'GET',
                     params: {
                        '_wpnonce': data.nonce,
                        //'ticket': data.ticket,
                        'mark': data.mark,
                        'mandant': data.mandant,
                        'query': data.query,
                        'rows': data.rows,
                        'sort': data.sort,
                        'sortDirection': data.sortDirection
                     },
                     headers: {
                        'content-type': 'application/json'
                     }
                  })
                  .then(resp => {
                     resolve(resp)
                  })
                  .catch(err => {
                     reject(err)
                  })
               })
            },

            getDocumentInfos({ commit }, data) {
               return new Promise((resolve, reject) => {
                  axios({
                     url: data.restURL + '/custom/v1/getDocumentInfos',
                     method: 'GET',
                     params: {
                        '_wpnonce': data.nonce,
                        //'ticket': data.ticket,
                        'mandant': data.mandant,
                        'noderef': data.noderef
                     },
                     headers: {
                        'content-type': 'application/json'
                     }
                  })
                  .then(resp => {
                     //console.log(resp.data.data)
                     //commit('setDocuments', resp.data.data)
                     resolve(resp)
                  })
                  .catch(err => {
                     reject(err)
                  })
               })
            },

            getCounter({ commit }, data) {
               return new Promise((resolve, reject) => {
                  axios({
                     url: data.restURL + '/custom/v1/getCounter',
                     method: 'GET',
                     params: {
                        '_wpnonce': data.nonce,
                        'ticket': data.ticket
                     },
                     headers: {
                        'content-type': 'application/json'
                     }
                  })
                  .then(resp => {
                     //console.log(resp.data.data)
                     //commit('setDocuments', resp.data.data)
                     resolve(resp)
                  })
                  .catch(err => {
                     reject(err)
                  })
               })
            },

            forceLogout({ commit }, data) {
               return new Promise((resolve, reject) => {
                  axios({
                     url: data.restURL + '/custom/v1/forceLogout',
                     method: 'GET',
                     params: {
                        '_wpnonce': data.nonce
                     },
                     headers: {
                        'content-type': 'application/json'
                     }
                  })
                  .then(resp => {
                     resolve(resp)
                  })
                  .catch(err => {
                     reject(err)
                  })
               })
            }

            // getUser({ commit }, data) {
            //    return new Promise((resolve, reject) => {
            //       axios({
            //          url: data.restURL + '/custom/v1/zammad/get_user',
            //          method: 'GET',
            //          params: {
            //             'user_id': data.user_id,
            //             'zammad_token': data.zammad_token,
            //             '_wpnonce': data.nonce
            //          },
            //          headers: {
            //             'content-type': 'application/json'
            //          }
            //       })
            //       .then(resp => {
            //          resolve(resp)
            //       })
            //       .catch(err => {
            //          reject(err)
            //       })
            //    })
            // },
         
         },
         getters: {
            isPortinvoiceLoggedIn: state => state.portinvoiceUserID,
            getUserEmail: state => state.email,
            getLoadingWorkingScreen: state => state.loadingWorkingScreen,
            getDocuments: state => state.documents,
            getAccessTicket: state => state.accessTicket,
            getLoadedPDFMetaData: state => state.documentWithMetaData,
            getPageMarkerForward: state => state.markerForward,
            getPageMarkerBackward: state => state.markerBackward,
            getAllMarkers: state => state.allMarkers,
            getPage: state => state.page,
            getMandant: state => state.mandant,
            getDocumentRelations: state => state.relations,
            getMaxRowsPerPageCommit: state => state.maxRowsPerPage,
            getSearchQuery: state => state.searchQuery,
            getSearchParameter: state => state.searchParameter,
            getTrefferAnzahl: state => state.trefferAnzahl,
            getSortSetting: state => state.sortSetting
         }

      }
   }
})


// WEBPACK FOOTER //
// ./src/store/index.js